import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Target, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const MuscleGain = () => {
  useEffect(() => {
    AOS.init({ duration: 600, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <Target size={64} className="service-hero-icon" />
            <h1 className="display-large">Muscle Gain Programs</h1>
            <p className="body-large">
              Strategic hypertrophy training designed to help you build quality muscle mass 
              efficiently and effectively.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img src="https://images.unsplash.com/photo-1690731033723-ad718c6e585a" alt="Muscle Building Training" />
            </div>
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">Build Quality Muscle</h2>
              <p className="body-medium">
                Building muscle requires more than just lifting heavy weights. It demands proper 
                programming, nutrition timing, and recovery strategies. My muscle gain programs 
                are designed to help you pack on quality size while staying lean and functional.
              </p>
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">High-Volume Training</h4>
                      <p className="body-small">Optimized rep ranges and training splits for maximum hypertrophy</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Nutrition for Growth</h4>
                      <p className="body-small">Calorie surplus strategies and meal timing for muscle building</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Recovery Planning</h4>
                      <p className="body-small">Strategic rest days and deload weeks for optimal adaptation</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Supplement Guidance</h4>
                      <p className="body-small">Evidence-based recommendations for supplements that actually work</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready to Build Muscle?</h2>
            <p className="body-large">Let's create a muscle-building program that delivers real results.</p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
              </Link>
              <Link to="/services"><Button className="btn-secondary">View All Services</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MuscleGain;
